module.exports = __webpack_public_path__ + "resources/img/solution_game_management_m.09398c8790d92d2a05842739656dd975.png";